<script setup lang="ts">
import { computed, watch } from 'vue';
import { Alert } from 'ant-design-vue';
import Bugsnag from '@bugsnag/js';

import { onParseJson, ParsedJsonEnum } from '@/util/json';

const props = defineProps<{ json?: string }>();

const parsedJson = computed(() => onParseJson(props.json));

watch(parsedJson, (value) => {
  if (value.status === ParsedJsonEnum.error) {
    Bugsnag.notify('Invalid JSON', (event) => {
      event.addMetadata('json', { json: props.json });
    });
  }
}, { immediate: true });
</script>

<template>
  <template v-if="parsedJson.status === ParsedJsonEnum.error">
    <Alert
      type="error"
      message="Error transforming this string into a JSON object"
      :description="json"
    />
    <slot name="error" :json="json" />
  </template>
  <slot v-else-if="parsedJson.status === ParsedJsonEnum.success" :json="parsedJson.data" />
  <slot v-else name="empty" />
</template>
